import React from 'react';
import '../styles/ProductSearch.css';

const ProductSearch = ({ 
  barcode, 
  setBarcode, 
  onSearch, 
  onBarcodeEnter,
  onBarcodeTab,
  message,
  messageType 
}) => {
  return (
    <div className="card search-card">
      <h2 className="card-title">
        <span className="icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
            <path d="M8.25 10.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z" />
            <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z" clipRule="evenodd" />
          </svg>
        </span>
        Product Lookup
      </h2>

      <div className="form-group">
        <label htmlFor="barcode" className="form-label">Barcode / SKU</label>
        <div className="input-with-button">
          <input
            id="barcode"
            type="text"
            value={barcode}
            onChange={(e) => setBarcode(e.target.value)}
            placeholder="Scan or enter barcode"
            onKeyDown={(e) => {
              if (e.key === 'Enter') onBarcodeEnter();
              if (e.key === 'Tab') onBarcodeTab(e);
            }}
            autoFocus
            className="form-input barcode-input"
          />
          <button onClick={onSearch} className="btn btn-primary">
            <span className="btn-icon">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-6">
                <path d="M8.25 10.875a2.625 2.625 0 1 1 5.25 0 2.625 2.625 0 0 1-5.25 0Z" />
                <path fillRule="evenodd" d="M12 2.25c-5.385 0-9.75 4.365-9.75 9.75s4.365 9.75 9.75 9.75 9.75-4.365 9.75-9.75S17.385 2.25 12 2.25Zm-1.125 4.5a4.125 4.125 0 1 0 2.338 7.524l2.007 2.006a.75.75 0 1 0 1.06-1.06l-2.006-2.007a4.125 4.125 0 0 0-3.399-6.463Z" clipRule="evenodd" />
              </svg>
            </span>
            Search
          </button>
        </div>
      </div>

      {message && (
        <p className={`message ${messageType === 'error' ? 'error' : 'success'}`}>
          {message}
        </p>
      )}
    </div>
  );
};

export default ProductSearch;